import { render, staticRenderFns } from "./ProduitQuantityEditor.vue?vue&type=template&id=0027d396&scoped=true&"
import script from "./ProduitQuantityEditor.vue?vue&type=script&lang=js&"
export * from "./ProduitQuantityEditor.vue?vue&type=script&lang=js&"
import style0 from "./ProduitQuantityEditor.vue?vue&type=style&index=0&id=0027d396&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0027d396",
  null
  
)

export default component.exports